module.exports = __webpack_public_path__ + "img/two.bb9db8bb.png";